/* eslint-disable no-useless-constructor */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { IsEnabled } from '../../helpers/authorization/Policies';
import { AppContext } from '../../helpers/context/AppContext';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { Module } from '../Module';

export default class Functions extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <AppContext.Consumer>
                {({ user }) => (
                    <>
                        <PageBreadCrumb
                            linkTo="/"
                            linkText="Home"
                            titleLeft="Modules"
                        />
                        <div className="mainContainer function-box-link">
                            <div className="bx--grid content full-width  ">
                                <div className=" bx--row ">
                                    <div className="bx--col-lg-12 functions--grid">

                                        <div className="bx--row">

                                            {IsEnabled(user, 'Incident') ? (<Module name="Incident" path="/incident"></Module>) : null}
                                            {IsEnabled(user, 'Audit') ? (<Module name="Audit" path="/listofaudit"></Module>) : null}
                                            {IsEnabled(user, 'Report') ? (<Module name="Report" path="/reportSummaries"></Module>) : null}
                                            {IsEnabled(user, 'Hoc Card') ? (<Module name="HOC" path="/hoccard"></Module>) : null}

                                        </div>


                                        <div className=" bx--row ">
                                            {IsEnabled(user, 'Emergency Drill') ? (<Module name="Emergency Drill" path="/drill"></Module>) : null}
                                            {IsEnabled(user, 'Inspection') ? (<Module name="Inspection" path="/inspection"></Module>) : null}
                                            {IsEnabled(user, 'Training') ? (<Module name="Training" path="/training"></Module>) : null}
                                            {IsEnabled(user, 'Insight Data') ? (<Module name="Insight Data" path={process.env.REACT_APP_PBI_DASHBOARD} isExternal></Module>) : null}
                                        </div>

                                        <div className=" bx--row ">
                                            {IsEnabled(user, 'Group Dashboard') ? (<Module name="Group Dashboard" path={process.env.REACT_APP_PBI_GROUP_DASHBOARD} isExternal></Module>) : null}
                                        </div>
                                    </div>

                                       
                                        {/* 
                                            <div
                                                className="bx--coll-lg-4 bx--coll-md-2 functions multiline button-tab-custom-content-function "
                                            >
                                                <Link to="#" className="bx--underline-none">
                                                    <div className="function-actions">
                                                        <div className="bx--row">
                                                            <div className="title--medium">Dashboard</div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>

                                            <div
                                                className="bx--coll-lg-4 bx--coll-md-2 functions multiline button-tab-custom-content-function "
                                            >
                                                <Link to="#" className="bx--underline-none">
                                                    <div className="function-actions">
                                                        <div className="bx--row">
                                                            <div className="title--medium">Emergency Drill</div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                         */}

                                    </div>
                                </div>
                            </div>
                    </>
                )}
            </AppContext.Consumer>
        );
    }
}
